export default {
    _parentContainer : null,
    _embed : null,
	init() {
        this._parentContainer = document.querySelector('[data-embed]');
        if (!this._parentContainer) {
        	return;
        }
        this._embed = this._parentContainer.children.item(0);

        if(!this._embed){
            return;
        }

        this._parentContainer.addEventListener(('click'), () => {
            this._embed.classList.add('clicked');
        });
        this._parentContainer.addEventListener(('mouseleave'), () => {
            this._embed.classList.remove('clicked');
        });
	}
};